module.exports = __webpack_public_path__ + "img/internal_spurgear.prt.61ac58e9.jpg";